module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_vm._v("South Wales Strife (1): Newport")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘The state of things at Newport is serious, and Mr Churchill, before he left, had considered the possibility of their applying for troops. He is most anxious to avoid their being used, and is doing all he can by offering to supply Metropolitan Police and otherwise to avoid the necessity; but of course if the Mayor or Magistrates requisition them, they must be ready to go. Mr Churchill asked me specially to impress on the War Office that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mounted troops")]), _vm._v(" should be sent. They are far more effective than infantry in dealing with a riot, and the risk of their employment leading to loss of life is much less.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_1",
      "id": "B_ch2_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("‘… in the Argentine they managed these things better; they would send artillery and machine guns, and give proper protection to their subjects.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_2",
      "id": "B_ch2_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It has been said that Churchill’s role in the Tonypandy riots of November 1910, and after, affected his reputation for the rest of his life. The Welsh historian Dai Smith recalled that when Rhondda cinemas showed films of Churchill in the 1950s, ‘we booed and booed and booed’ at his appearance."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_3",
      "id": "B_ch2_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" It is still the case that ‘in Wales the resentment lingers today’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_4",
      "id": "B_ch2_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Furthermore the phrase attributed to him –‘if the Welsh are striking over hunger, we must fill their bellies with lead’ – endures even further afield."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_5",
      "id": "B_ch2_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" He never said it, of course, but the myth, as myths do, persists. In fact his approach to, and policy regarding, riot and civil disorder arising from industrial disputes had been portended earlier in the year in a location not far removed from Tonypandy and the Rhondda.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The May 1910 Newport Dock Strike grew out of the decision by one of the users of the port, the Empire Transport Company (a subsidiary of Houlder Brothers Company), to unilaterally alter a formerly agreed payment system pertaining to dock workers. Industrial relations at Newport, and indeed the wider south Wales waterfront, had generally been placid largely because of the ‘unbelligerence’ of various local concerns."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_6",
      "id": "B_ch2_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" That situation dramatically changed on 14 May when the vessel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Indian Transport")]), _vm._v(" arrived and Houlder’s announced that it would be loaded by men paid by the day rather than on a piece-work system. This directly affected around a hundred dockers who refused to work under the terms offered, but their action was supported by the rest of the workforce who feared that the change was merely the thin end of a wedge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("Houlder’s, having ‘upset the well-established relations between unions and employers on the docks at Newport,’ refused to compromise and arranged for so called ‘free labour’ (non-union dockers) to be sent from London."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_7",
      "id": "B_ch2_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" When these, fifty-two in number, arrived, a dock-wide unofficial strike was called on 18 May and some 300 Newport dockers prevented this blackleg labour from working the wharfs. Violence broke out and unsuccessful attempts were made to board "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Indian Transport")]), _vm._v(". These culminated in the ship’s captain inviting two of the strikers onboard to address the blacklegs, who were offered their train fares back to London and guaranteed safe passage to the station, if they immediately left the ship. This offer was accepted."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_8",
      "id": "B_ch2_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The next day, a procession of some 2,000 dockers, led by a band, paraded through Newport in an effort to gain support for their actions whilst, rather less publicly, negotiations commenced to settle the issue. These involved not only union officials and the management of the Alexandra (Newport and South Wales) Docks and Railway Company"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_9",
      "id": "B_ch2_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" but also the Mayor of Newport, all of whom were anxious to resolve the matter quickly."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_10",
      "id": "B_ch2_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" This aspiration, though, was not shared by Houlder Brothers, who arranged for further blacklegs to be brought to Newport by ship under the auspices of the Shipping Federation. Founded as ‘a fighting machine to counter strikes’,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_11",
      "id": "B_ch2_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" it had formed a Labour Department in the 1890s, one of the main functions of which was to supply blackleg labour."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_12",
      "id": "B_ch2_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" They asked the Home Office for assistance on 19 May:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Men employed by owners to load steamer Indian Transport at Newport Monmouthshire have been attacked, assaulted and grossly intimidated by other labourers on strike and are consequently unable [to] work. Owners are suffering great loss from detention of vessels. Local authorities are unable provide police protection without strong reinforcements from outside. Respectfully request that you will take necessary steps maintain law and order and afford such protection as will enable men engaged to pursue their lawful occupation: matter is urgent. Trust that immediate action be taken."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_13",
      "id": "B_ch2_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Churchill wasn’t there. Prior to journeying to Switzerland and northern Italy for a holiday, he was at the Dorset estate of the Welsh industrialist Ivor Guest, Baron Wimborne, who was his uncle by marriage."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_14",
      "id": "B_ch2_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" The Permanent Under-Secretary of State at the Home Office, Sir Edward Troup,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_15",
      "id": "B_ch2_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" telegraphed him there following receipt of the above telegram and after a visit in person from ‘three representatives of the Empire Transport Company’ who had called ‘to represent that’:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("in connection with [a] strike of stevedores … serious disturbances have occurred, [and] that police have failed to give adequate protection and that their free workmen have been assaulted and intimidated. They ask Home Secretary to intervene. I have told them local police are entirely responsible, and if numbers insufficient should obtain assistance from other forces. I have also communicated with Board of Trade who had not heard of dispute but Mitchell"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_16",
      "id": "B_ch2_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" is now communicating with firm and they will watch the case and "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("give help if possible. Meantime may I telegraph to local police to remind them of their responsibility to maintain order and prevent outrage or intimidation?"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_17",
      "id": "B_ch2_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Churchill’s reply of that day authorised Troup to telegraph in the vein indicated, and stated that any public announcement should mention the intervention by Mitchell and the Board of Trade. He continued:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Empire Transport Company should be made to realise that employing large droves of men from London to break the strike is a very strong order. Do not on any account give them or the public the impression that we approve their action."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_18",
      "id": "B_ch2_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Troup then telegraphed Councillor William Blackburn, the Mayor of Newport,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_19",
      "id": "B_ch2_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" explaining the Home Secretary’s position:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("He desires to remind you that police and magistrates are responsible for maintenance of order and prevention of outrage or intimidation and that if local police are insufficient immediate steps should be taken to obtain assistance from other police forces."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_20",
      "id": "B_ch2_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Blackburn replied that the Watch Committee, the local government body which oversaw policing, had authorised the Head Constable"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_21",
      "id": "B_ch2_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" of the Newport Borough Police to take ‘all necessary steps for the preservation of peace’ and that the Committee would meet the following day to further consider the matter."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_22",
      "id": "B_ch2_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" The manpower immediately at the disposal of Head Constable Allan Inderwick Sinclair was, however, limited; the Newport Borough Police Force numbered 106 personnel all told."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_23",
      "id": "B_ch2_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" This was, quite obviously, hopelessly inadequate given the number of strikers they were likely to encounter. Sinclair reported his difficulties in this regard on 20 May:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("[The] Watch Committee [are] alive to [the] situation and will require 500 men and 20 mounted officers to afford adequate protection if any further labour [is] imported. Can only get 250 from neighbouring forces. Do not propose to provide additional assistance until informed further importation of labour [is] certain and date. Can [the Watch] Committee obtain adequate notice of this and what men can be sent?"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_24",
      "id": "B_ch2_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Troup telegraphed this information to Churchill the next day, adding that Sir Edward Richard Henry, the Commissioner of the London Metropolitan Police, had been contacted and would send the required reinforcements, of 250 foot and 50 mounted police, if necessary. Churchill replied approving this, also stating that ‘if they want more they must have more’. He also informed Troup that ‘from tomorrow’ (i.e. Sunday, 22 May) he could be reached at the Hotel du Palais, Lucerne."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_25",
      "id": "B_ch2_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Churchill, as Home Secretary, was the legal police authority for the Metropolitan Police and the Commissioner, equivalent to the Chief or Head Constable in other forces, was subject to his general direction."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_26",
      "id": "B_ch2_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Some "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("17,000 strong, the Metropolitan Police was the only force that had duties of national rather than merely local importance, and could be used as a kind of strategic reserve to be deployed as necessary at the Government’s behest. In so doing it formed a, comparatively weak, substitute for those centralised police forces, or gendarmeries, such as for example existed in France, Italy and Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The multi-polar communication over the ‘Victorian Internet’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_27",
      "id": "B_ch2_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" continued, with Troup passing on Churchill’s consent to Councillor Blackburn on Saturday, 21 May. He also pointed out that ‘only in the last resort’ and in a situation of ‘grave emergency’ should the application to the Metropolitan Police be actually made."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_28",
      "id": "B_ch2_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" That the ‘last resort’ might well have been upon them was communicated in turn that day by Head Constable Sinclair, who complained that his telegram of 20 May, asking for information concerning reinforcements, remained unanswered. He also imparted the news that the ‘imported labour’ was due to arrive the very next day and thus it was ‘essential we should have 250 Metropolitan Police to reach here by two o’clock Sunday afternoon [22 May]’ and that the request had been made to the Commissioner."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_29",
      "id": "B_ch2_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A telegram from the Shipping Federation also arrived at the Home Office, confirming the urgency as related by Sinclair and indeed attempting to up the ante:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fifty-five labourers for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Indian Transport")]), _vm._v(" will arrive Newport Sunday evening nine o’clock. Owners have warned [the] Mayor [of the] necessity for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("military protection")]), _vm._v(" as [the] attitude and large numbers of strikers threaten very serious danger to persons carrying on work at this steamer. Trust you will take all possible steps [to] assist [the] owners to obtain protection from violence."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_30",
      "id": "B_ch2_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This came amongst a flurry of telegraphic messages that Saturday, in which Troup assured the Head Constable and the Mayor that the police reinforcements had been sanctioned. On the other hand, the Mayor informed Troup that ‘severe riots [were] anticipated here in connection with the dock strikes’ and confirmed that the warning from the Shipping Federation in terms of ‘military protection’ had been acted upon:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("At meeting of borough magistrates here this morning it was unanimously resolved that the War Office be requested to hold in readiness two hundred infantrymen and one hundred mounted men to assist the local police and five hundred imported police. Duplicate of this telegram sent [to the] Secretary of State for War."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_31",
      "id": "B_ch2_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Troup attempted to contact his opposite number at the War Office, the Permanent Under-Secretary Sir Edward Ward, and through him the Minister for War Richard Haldane:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The state of things at Newport is serious, and Mr Churchill, before he left, had considered the possibility of their applying for troops. He is most anxious to avoid their being used, and is doing all he can by offering to "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("supply Metropolitan Police and otherwise to avoid the necessity; but of course if the Mayor or Magistrates requisition them, they must be ready to go. Mr Churchill asked me specially to impress on the War Office that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mounted troops")]), _vm._v(" should be sent. They are far more effective than infantry in dealing with a riot, and the risk of their employment leading to loss of life is much less."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_32",
      "id": "B_ch2_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He sent copies of these communications to Churchill, adding that he had been unable to reach anyone at the War Office either by telephone or messenger; he quipped that if any ‘possible invader’ chose to land on a Saturday afternoon the War Office would only discover it the following Monday. The import of his message to Sir Edward Ward was also conveyed: ‘[I] explained your views about mounted troops, and of course said that you were doing all you could to avoid the necessity of [them] being there at all.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_33",
      "id": "B_ch2_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Nevertheless, the Mayor of Newport was informed by Ward that the General Officer Commanding-in-Chief at Chester"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_34",
      "id": "B_ch2_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" ‘has been communicated with and will comply with such requisition as may be found necessary’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_35",
      "id": "B_ch2_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" There were small military forces available locally: a cavalry/artillery barracks (now Raglan Barracks) was located at Allt-yr-yn, Newport, and the 1st Battalion of the Monmouthshire Regiment was based at Stow Hill, Newport. However, and as several authors have noted, army policy was to avoid using troops who may have had local affiliations: ‘when detailing troops for duty in strike areas care was always taken not to send any units with territorial connections in those particular localities.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_36",
      "id": "B_ch2_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" The reasoning behind this was straightforward; they might have sympathised with the strikers. Furthermore, if called on to apply deadly force then they may well have baulked at doing so against family and friends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Troup also received a further message from Councillor Blackburn, telling him that all local police resources were exhausted, but that he had been promised ‘sixty men from Bristol and forty from Merthyr’ on Sunday, 22 May, and was hoping to get forty each from the Glamorgan County and Monmouthshire County forces. These latter eighty were, however, doubtful. He reiterated that the imported labour was arriving ‘in two sections tomorrow, one by rail, the other by water’ and that the reinforcements from London were required."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_37",
      "id": "B_ch2_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The situation on the evening of Saturday, 21 May looked grim; the blackleg labour was due to arrive the following evening and would undoubtedly provoke a violent reaction. Efforts to contain this involved the despatch of 300 Metropolitan Police, including 50 mounted officers, plus the circa 180-strong contingent assembled locally. In addition, military forces from the Army’s Western Command could be called into play as a last resort.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two events occurred overnight. At 10.45pm Frank Houlder, the chairman of Houlder Brothers, called at Troup’s house to air his concerns about the situation. According to Troup’s report of the incident compiled shortly afterwards, the shipping magnate ‘seemed to have dined and was much excited’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_38",
      "id": "B_ch2_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" It went on to relate that Houlder had become convinced that ‘500 strikers were assembled on "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("the dock; that there were only three police on duty; and that his men were trying to save the vessel from attack by getting her off to a buoy in the river’. He further claimed that forty of his men were being murdered ‘at that moment’ and that Troup, and by extension the Government which he held responsible, should ‘instantly take steps to save them’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Efforts to calm Houlder by explaining that the local authorities, and not the Government, were responsible for maintaining order, but that the Government were sending 300 police by special train tomorrow to help in that regard, were seemingly unsuccessful. Troup records that the response to this was that ‘in the Argentine they managed these things better; they would send artillery and machine guns, and give proper protection to their subjects’. To add to Troup’s woes, Houlder’s secretary arrived and ‘assumed the same offensive and bullying manner as his chief’. The two eventually left, stating that they would visit the Admiralty and demand assistance there. Troup telegraphed Sinclair in Newport to enquire if there were any truth in Houlder’s assertions, and received ‘in an hour or two’ the assurance that all was calm. He was also informed that a conference was then in progress which the Head Constable hoped would lead to a settlement of the dispute."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_39",
      "id": "B_ch2_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That Sinclair was not hoping in vain became apparent to Troup when a telegram arrived at ‘between 2 and 3 o’clock this [Sunday, 22 May] morning’. The sender was Councillor Blackburn who had, in company with several others, also been burning the midnight oil:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Further to telegrams of today, [the] Newport labour dispute [has] just been settled in [a] conference with [the] Mayor and representatives of [the] masters and men, and with [the] assistance of the Board of Trade. Police and military assistance not now required. Have communicated direct with Scotland Yard and officer commanding troops at Chester to this effect."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_40",
      "id": "B_ch2_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A further communication from Isaac Mitchell followed some ten hours later. This informed Troup that his arrival had been ‘opportune’ and that ‘Both parties [had] agreed to Board of Trade arbitration. All men resume work tomorrow morning [Monday, 23 May].’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_41",
      "id": "B_ch2_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" These latest developments were communicated to Churchill at Lucerne, with Troup remarking that he felt ‘sure that the satisfactory result comes directly from your policy of supporting the authorities on the one hand and on the other insisting on conciliation’. He added that, in relation to his interview with Houlder, if he ‘bullied his stevedores as he tried to bully me, it is no wonder there was a strike’ and informed the Home Secretary that he had, at 3 o’clock that morning, stopped the movement of the Metropolitan Police reinforcements."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_42",
      "id": "B_ch2_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Churchill’s reply stated that he was ‘very pleased’ with the settlement and asked that formal thanks be sent to the Board of Trade in terms of Isaac Mitchell’s ‘excellent work’. Thanks in the form of ‘civil letters’ were also to be written to Councillor Blackburn and Head Constable Sinclair, with the caveat that they should not be sent ‘if you see any serious reason not known to me’. He also "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("transmitted the text of a telegram that he wanted despatching to Houlder Brothers:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Begins. I desire to thank you personally for the assistance you have rendered in the friendly settlement of a dangerous dispute and for the consideration with which you have treated me throughout. I trust your difficulties will not recur. CHURCHILL. Ends."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_43",
      "id": "B_ch2_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As stated, the terms of the settlement brokered by Mitchell meant that work at Newport Docks would resume. The formerly agreed payment system pertaining to piece work would apply, and the question of alteration to it would be submitted to arbitration."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_44",
      "id": "B_ch2_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" There was, though, to be a coda to the affair, which threatened major trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The employers’ representative at the meetings which reached the settlement was John Macauley, the General Manager of the Alexandra Docks. For his part in it, and his ‘conciliatory spirit’ during the negotiations, he received one of the letters Churchill had asked to be sent."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_45",
      "id": "B_ch2_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" However, Houlder Brothers and the Shipping Federation, and there was ‘no other employer’s organisation quite as aggressive and as unscrupulous as the Shipping Federation,’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_46",
      "id": "B_ch2_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" disavowed the agreement and upended the ‘friendly settlement’ upon which they had just been congratulated. The Federation telegraphed the Home Office on the afternoon of Monday, 23 May informing them not only of this repudiation but also that further blackleg labour was due to land at eight o’clock that very evening:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("At [the] request of Houlder Brothers, [the] Shipping Federation have engaged fifty men [to] load their vessel … These men are now on their way … [The] Chairman [of the] Watch Committee and Mayor were advised [of] this proceeding yesterday and this afternoon and requested [to] provide protection. Reply has been received … [and] protection will not be granted … Request [that] you will point out to [the] Local Authorities their duty. Their refusal [to] provide protection is based upon [the] result of some negotiations between certain officials of [the] Union and [the] General Manager of [the] Dock Company to which [the] owners of [the] vessel were not parties and by which they decline to be bound."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_47",
      "id": "B_ch2_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The men referred to were already at Newport aboard the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lady Jocelyn")]), _vm._v(", a sailing ship (with auxiliary steam propulsion) owned by the Shipping Federation and used specifically for conveying blacklegs to wherever they were required."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_48",
      "id": "B_ch2_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" It was obvious to all concerned that if they were landed, which they would have to be in order to load the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Indian Transport")]), _vm._v(", then serious disorder would ensue. Troup replied to the Shipping Federation, stating that Churchill ‘thinks that you should at once stop the sending to Newport of [the] men mentioned … you will incur grave responsibility if, in disregard of agreement by representatives you import unnecessary labour into Newport’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_49",
      "id": "B_ch2_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Shipping Federation replied that evening, stating that the ‘Secretary of State is misinformed’ and that Houlder Brothers had ‘no representatives’ at the "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("meeting where the appeal to arbitration was agreed. They complained that the vessel was still ‘blocked and suffering ruinous delay’. The nub of the matter from the Federation’s perspective was outlined as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Position apparently is that local authorities are averse from giving protection and are seeking [a] pretext for disregarding their duty. Too late now [to] stop [the] men. Respectfully submit they are entitled to be safeguarded in pursuit of their lawful calling. Beg you will do what lies in your power to save them from the violence of Trade Unionists at Newport."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_50",
      "id": "B_ch2_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This was a transparent attempt to force the Home Office, and Government more generally, into action. In the severely practical sense, inasmuch as the Metropolitan Police and military reinforcements had been stood down, it was an impossible demand to satisfy in the postulated timeframe. Troup’s reply reiterated his earlier point: ‘if you land men at Newport or bring them into [the] docks in present circumstances you will incur [a] very grave responsibility’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_51",
      "id": "B_ch2_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Indeed, such action would have entirely invalidated the tactics employed by Head Constable Sinclair, and endorsed by the Watch Committee, for keeping the situation under control. Given the limited police manpower, these tactics devolved on avoiding a situation where conflict and violence would likely occur. This, in turn, meant preventing the dockers and blacklegs from coming into contact with one another, which was a simple enough proposition provided the latter remained aboard the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lady Jocelyn")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_52",
      "id": "B_ch2_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Until such time as Sinclair and the Watch Committee were prepared to guarantee their safety, there they would remain. This was, of course, not at all to the satisfaction of the Shipping Federation, which replied stating that they had ‘been able to arrange [to] stop men en route’. They went on, ‘but you will understand they cannot be indefinitely held back in this way. [The] local authorities have refused protection pending an interview with you tomorrow.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_53",
      "id": "B_ch2_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile a meeting had been held that afternoon, 23 May, at Houlder Brothers’ offices at 146 Leadenhall Street, London. In attendance on the one hand were the Board of Trade’s Isaac Mitchell, who had brokered the 22 May settlement, John Macauley of Alexandra Docks, and William Blackburn, the Mayor of Newport. On the other were Frank and Maurice Houlder, plus Cuthbert Laws, the General Manager of the Shipping Federation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Laws had been the Shipping Federation’s first Secretary before succeeding his father, George Laws, as General Manager in 1901, and he is an interesting character. Described as having a ‘powerful personality’, he is credited, if that is the correct term, with relishing conflict. The author of the Shipping Federation’s official history put it thus: ‘He never shirked – sometimes, indeed, he seemed to seek – a fight, but unlike so many fighters, he knew well when the time had come for peace and reconstruction.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_54",
      "id": "B_ch2_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" Those who opposed him had a slightly different perspective: ‘Mr Cuthbert Laws and his colleagues hate trade unionism as the devil hates holy water, and would do anything in their power to thwart and destroy it.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_55",
      "id": "B_ch2_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Evidently the time for ‘peace and reconstruction’ was not yet nigh, and consequently thwarting and destruction still held sway. According to "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("Mitchell’s account, they were told that the Shipping Federation had held a meeting earlier and decided not to recognise the agreement. It was, he said:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("evident that the firm [Houlder Brothers] had put itself entirely under the control of Mr Laws, who made no secret of his intentions to import men … on his conditions. He demanded police protection from the Mayor and altogether made any prospect of settlement impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The position now is that a recurrence of all the trouble is threatened by the actions of this one firm, all the men being employed by the other firms being back at work. A ship’s general cargo is lying at the docks ready to be loaded into one of Messrs Houlder’s ships which is alongside. If this could be got away Mr Macauley would, if he had power, decline to accept cargo at the dock for this firm and so save further trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Macauley and the Mayor of Newport will call today [24 May 1910] at Gwydyr House [the location of the Board of Trade’s Labour Department] at 12 noon. The Dock Board meets in London at 2 pm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Laws is meanwhile pressing the Mayor for police protection for the new men he intends sending to Newport. If they are sent a general upheaval seems inevitable."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_56",
      "id": "B_ch2_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Troup forwarded updates on the situation to Churchill, who was then at Lugano, Switzerland, adding a note to Mitchell’s report. In this he argued that Houlder Brothers were ‘behaving very badly. On Sunday they or their agents so far accepted the agreement … and it was only on Monday [that] they decided to repudiate.’ Further evidence of Houlder’s intransigence as perceived by Troup was provided. He noted that Macauley had offered to make up any financial loss Houlder’s might incur if they would agree to their vessel being loaded under the agreed, piece work, system. ‘But,’ he said, ‘they would have none of it’ and their hostility towards Macauley became so strong that it was feared they would resort to physical violence. Troup also reported that he had seen Councillor Blackburn that day [24 May], and that the Mayor was ‘very much disturbed’ at Houlder Brothers’ conduct. Troup reassured him:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I told him that it was his duty to do his utmost to maintain order; but that he was clearly entitled to tell Messrs Houlder that he could not perform impossibilities, [and] that if they imported ‘free labour’ in [circumstances] which must necessarily give rise to uncontrollable disorder, their responsibility would be very grave."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_57",
      "id": "B_ch2_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In fact both the Shipping Federation and Houlder Brothers had been warned on the evening of Monday, 23 May by Mark Mordey JP, the Chairman of Newport Watch Committee, that they could not undertake the responsibility of protecting any ‘imported men’:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Five hundred additional police and mounted men would have been in town yesterday had we not been informed by all parties concerned that police and "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("military arrangements might be cancelled. To now import free labour would, in my opinion, be little short of madness after the settlement has been announced. All other workmen [have] gone back to work on [the] faith of it and the town [is] settling down quietly. Instead of 500, it would require at least double that number to give protection, having regard to fearful results all through the town. Cannot now undertake [the] responsibility of protecting imported men."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_58",
      "id": "B_ch2_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To reinforce the last point, a ‘special meeting’ of the Watch Committee was convened on the afternoon of Tuesday, 24 May, following which their deliberations were published:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Having heard the telegrams passed between the chief-constable, the chairman of the watch committee, Messrs Houlder Bros, and the Shipping Federation … this committee are not prepared to provide additional protection, which would be necessary if labour is imported, until commanded to do so by the Home Office, and that any labourers proposing to come to Newport be warned that it is unsafe to do so in existing circumstances."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_59",
      "id": "B_ch2_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The unnamed author of the article which included both the above communications, and was published in the Cardiff-based "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Evening Express and Evening Mail")]), _vm._v(" as well as being syndicated more widely, also drew a highly pertinent conclusion: ‘The whole contention has now been changed to one of not the employers versus the men, but the Shipping Federation on the one side and the watch committee of Newport on the other.’ However, given that the Committee had effectively handed the decision over protection for the blacklegs over, or perhaps up, to the Home Office, then that department became in effect one of the contenders in its place. Be that as it may, negotiations continued between Houlder Brothers and the Shipping Federation on the one hand, and the Mayor of Newport and the Trade Unions on the other, but to no avail; the former continued to refuse to accept the 22 May settlement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Churchill was kept abreast of these developments. However, in the formal context, the responsibilities of the Home Secretary had been placed in the hands of another Secretary of State, Richard Haldane, Minister for War, during his absence. It was then to Haldane that Councillor Blackburn, in the absence of any impending resolution to the matter, wrote on Thursday, 26 May calling his attention to the ‘appalling state of things’ if the blacklegs were allowed to land:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We confidently expect that … there will be a great strike throughout the town and docks, involving possibly a stoppage of collieries in the Monmouthshire district in consequence of their being unable to ship their coal at the docks, and quite possibly an extension of the strike to other ports in the Bristol Channel. In our town the corporation employés have already passed a resolution to cease work if free labour be imported … To adequately protect the free labourers … from the violence of the enormous crowds … would require a police force which is estimated by the Head Constable at "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("500 additional men at least, and having regard to the necessity of relieving the constables so engaged it means double the number to be brought into the town.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The letter continued by stating that the local authorites were ‘most seriously apprehensive’ should Houlder Brothers be ‘permitted to carry out their intentions’ and that there would ‘be serious riot and bloodshed’. Councillor Blackburn laid the blame for the entire issue on the shipping company:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is only fair to state that the men honourably and faithfully carried out the terms of the agreement which was entered into by their leaders on their behalf (although many dissented from its terms), by returning to their work on Monday morning, and it is the indignation which will arise when they think that it has been departed from by one section of employers which will produce the stormy passions which we apprehend.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It concluded by re-emphasising his, and the local authorities’, ‘anxious fear for the peace and order of the town if the importation of free labour is allowed’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_60",
      "id": "B_ch2_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Haldane held a meeting with Houlder Brothers that same day with Troup in attendance. The Home Office position, covering four points as determined by the opinion of the Government’s legal advisers, the Solicitor General, Sir Rufus Isaacs, and the counsel to the Inland Revenue and the Treasury, Sidney Rowlatt,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_61",
      "id": "B_ch2_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" was put ‘plainly and courteously’ to the shipowners. This was that whilst it was the duty of the local authorities to provide sufficient force ‘to suppress disorder, riot or outrage’, it was also their duty to use all legal means to prevent occasions for such conflicts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the context under discussion, this would firstly involve attempting to prevent crowds from assembling on the docks. Secondly, they should attempt to ‘dissuade’ Houlder Brothers and their agents from landing the imported labour, and also ‘dissuade’ that labour from landing. The third point involved the local authorities supporting the dock company ‘in any action they may be advised to take’ to exclude both imported labour and/or strikers from the docks. The final point was the most important and controversial: in the ‘last extremity’ they may ‘forbid and prevent’ the imported labour from actually landing. This point, which ‘would mean preventing Houlders from exercise of what, in ordinary circumstances, would be their legal rights’, would only be taken if the local authority can show that landing imported labour ‘would inevitably cause riot and bloodshed, and would lead to a general and disastrous strike’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_62",
      "id": "B_ch2_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" Given Councillor Blackburn’s opinion as noted above, it was obvious that the ‘last extremity’ had already been arrived at so far as the local authorities were concerned. Accordingly, the Newport Borough Police would indeed ‘forbid and prevent’ the blacklegs from landing. Houlder Brothers and the Shipping Federation, which Churchill later opined ‘had not made things as easy as they could throughout the matter, and who seemed to think that any moment an unlimited supply of horse, foot, and artillery would be at their disposal’, now had little option. They accordingly "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("agreed to submit the matter to arbitration as per the agreement reached some six days earlier. Thus, as the Home Secretary put it, ‘the second of the two crises passed peacefully away’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_63",
      "id": "B_ch2_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Churchill’s explanation of the matter came after the event and during a debate in the House of Commons, on 22 June 1910, over the role of the Board of Trade and the Home Office in the dispute. The opposition sought to censure these departments for preventing, as it was put by Sir Frederick Banbury, Conservative MP for the City of London, an employer (Houlder Brothers) from employing labour as they liked and for being ‘forced into arbitration by threats that the forces of the Crown will be used to compel him to arbitrate’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_64",
      "id": "B_ch2_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" The Home Secretary was able to justify the conduct of his department, and that of the local authorities, arguing that it provided a temporary solution specific to that time and place. It did not herald the establishment of a general principle. Indeed as Haldane, who was the man on the spot, as it were, at the time, phrased it: ‘what would otherwise be legal action on the part of Messrs Houlder would be illegal if persisted in, in the then circumstance.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_65",
      "id": "B_ch2_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Haldane had, temporarily and nominally, been in charge whilst Churchill was away, there is no doubt that the policy adopted by the Home Office during the course of the dispute was Churchill’s. There is a caveat, however, to the latter statement. The prime mover behind developing a plan for centrally directed responses to local unrest, since his appointment in 1908, had been Troup."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_66",
      "id": "B_ch2_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" Be that as it may, the responsibility for it was Churchill’s and, even if not actually initiated by him, the correspondence quoted has shown that he approved it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also demonstrated therein is that his approach from the start was conciliatory and de-escalatory. The offer to send Metropolitan Police as reinforcements, in the stead of military aid, can also be viewed in terms of a desire to lower the temperature and prevent bloodshed. Using the Metropolitan Police, as already noted the only force under central Government control, as a strategic reserve was not novel. Home Secretaries of the day had despatched several hundred Metropolitan officers to trouble spots during disturbances relating to the New Poor Law and Chartist protests in the 1830s and 1840s."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_67",
      "id": "B_ch2_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" Indeed Asquith, as Home Secretary under William Ewart Gladstone in 1893, had despatched 400 Metropolitan Police to Yorkshire to assist with the widespread unrest there occasioned by a miners’ strike."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_68",
      "id": "B_ch2_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" What was rather more innovatory, however, as argued by Jane Morgan for example,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_69",
      "id": "B_ch2_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" was that in taking the approach it did, Churchill’s Home Office arrogated to itself an expanded, supervisory, role with the no doubt grateful acquiescence of Newport Watch Committee. This was something of a constitutional novelty. Asquith, in the case above mentioned, had entirely disclaimed Home Office responsibility for the preservation of public order (outside London). The responsibility for the prevention and suppression of local disorder lay, he said, where it had always lain ‘from the earliest period of our history, with the Local Authority’. He did, though, acknowledge that the Home Secretary was the ‘channel through which the demands of a Local Authority for "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("assistance, when their own police resources are insufficient … may be made’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_70",
      "id": "B_ch2_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" That responsibility, as the several communications from the Home Office quoted have made plain, had not changed in 1910, though the duties of the Home Secretary had been clarified somewhat by a Select Committee report of 1908."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_71",
      "id": "B_ch2_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" In any event under Churchill, and at Newport, the Home Secretarial ‘channel’ had flowed in both directions. Indeed, whilst he had yet to completely overturn the ‘existing procedure’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes#A_ch2_72",
      "id": "B_ch2_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" for dealing with industrial strife and disorder, he had shown that he was quite prepared to do so.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117db72a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter2.vue
// module id = 81
// module chunks = 0